<template>
  <div >
    <ServerComponent></ServerComponent>


  </div>
</template>
<script>
import ServerComponent from "../Components/ServerComponent";
export default {
  name: "Server",
  components: {
    ServerComponent
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {}
};
</script>
<style scoped>
</style>
